export const SocialData=[
    {
        platform:"Instagram",
        link:"https://www.instagram.com/layan2k2/",
        icon: require("../../assets/icons/instagram.png"),
    },
    {
        platform:"LinkedIn",
        link:"https://www.linkedin.com/in/leslieshumba/",
        icon: require("../../assets/icons/in.png"),
    },
    {
        platform:"Skype",
        link:"skype:leslie.shumba2?chat",
        icon: require("../../assets/icons/skype.png"),
    },
    {
        platform:"Twitter",
        link:"https://twitter.com/layan_2k",
        icon: require("../../assets/icons/twitter.png"),
    }
]